(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["latest-videos-playlist"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var feature = root.querySelector('[data-video-feature]');
    var featureButton = root.querySelector('[data-video-feature-open]');
    var featureImage = root.querySelector('[data-video-feature-image]');
    var featureDuration = root.querySelector('[data-video-feature-duration]');
    var featureKicker = root.querySelector('[data-video-feature-kicker]');
    var featureCategory = root.querySelector('[data-video-feature-category]');
    var featureTitle = root.querySelector('[data-video-feature-title]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-video-item]'));
    var page = root.querySelector('[data-video-page]');
    var dialog = root.querySelector('[data-video-dialog]');
    var dialogTitle = root.querySelector('[data-video-dialog-title]');
    var frame = root.querySelector('[data-video-frame]');
    var close = root.querySelector('[data-video-close]');
    var dismiss = root.querySelector('[data-video-dialog-dismiss]');
    var lastTrigger = null;

    function update(item) {
      if (!item || !feature) return;
      feature.dataset.videoId = item.dataset.videoId;
      feature.dataset.videoTitle = item.dataset.videoTitle;
      featureImage.src = item.dataset.videoPoster;
      featureImage.alt = item.dataset.videoAlt;
      featureDuration.textContent = item.dataset.videoDuration;
      featureKicker.textContent = item.dataset.videoKicker;
      featureCategory.textContent = item.dataset.videoCategory;
      featureTitle.textContent = item.dataset.videoTitle;
      items.forEach(function (videoItem) {
        var active = videoItem === item;
        videoItem.classList.toggle('is-active', active);
        videoItem.setAttribute('aria-pressed', String(active));
        var action = videoItem.querySelector('.latest-videos-playlist__item-action');
        if (action) action.textContent = active ? 'Featured now' : 'Select video';
      });
      page.textContent = String(items.indexOf(item) + 1).padStart(2, '0') + ' / ' + String(items.length).padStart(2, '0');
    }

    function openVideo(item, trigger) {
      if (!item || !dialog || !frame) return;
      lastTrigger = trigger || featureButton;
      dialogTitle.textContent = item.dataset.videoTitle || 'Latest video';
      frame.src = 'https://www.youtube.com/embed/' + item.dataset.videoId + '?autoplay=1&rel=0&modestbranding=1&playsinline=1&enablejsapi=1&origin=' + encodeURIComponent(window.location.origin);
      dialog.hidden = false;
      dialog.classList.add('is-open');
      dialog.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      close.focus();
    }

    function closeVideo() {
      if (!dialog || !frame) return;
      frame.src = 'about:blank';
      dialog.classList.remove('is-open');
      dialog.setAttribute('aria-hidden', 'true');
      dialog.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        update(item);
        if (window.matchMedia('(max-width: 749px)').matches) openVideo(feature, item);
      });
    });
    featureButton.addEventListener('click', function () { openVideo(feature, featureButton); });
    close.addEventListener('click', closeVideo);
    dismiss.addEventListener('click', closeVideo);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !dialog.hidden) closeVideo();
    });
    update(items[0]);
  }

  document.querySelectorAll('[data-latest-videos-playlist]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-campaign-codex"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeOfferCampaign = (root) => {
      if (!root || root.dataset.codexOfferReady === 'true') return;
      root.dataset.codexOfferReady = 'true';
      const panels = root.querySelectorAll('[data-codex-offer-panel]');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        panels.forEach((panel) => panel.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      }, { threshold: 0.14 });

      panels.forEach((panel) => observer.observe(panel));
    };

    const initializeAllOfferCampaigns = () => {
      document.querySelectorAll('[data-codex-offer-section]').forEach(initializeOfferCampaign);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAllOfferCampaigns, { once: true });
    } else {
      initializeAllOfferCampaigns();
    }

    document.addEventListener('shopify:section:load', initializeAllOfferCampaigns);
  })();

  } catch(e) { console.error(e); }
})();
})();
